import { Card, CardContent, CardHeader, CardTitle } from 'Assessment/src/components/ui/card';
import { API_SERVER } from 'config/constant';

interface ScenarioCardProps {
  data?: any;
  type?: string;
  style?: React.CSSProperties; 
  contentByLanguage?: string | null;
}

export const ScenarioCard = ({ data,type,style,contentByLanguage }: ScenarioCardProps) => {
  const scenarioText =
    contentByLanguage ||
    data?.contentByLanguage ||
    data?.blockText ||
    data?.speechContent ||
    data?.speech ||
    data?.content ||
    '';

  const audioSource = data?.audio
    ? (typeof data.audio === 'string' && data.audio.startsWith('http')
        ? data.audio
        : `data:audio/*;base64,${data.audio}`)
    : null;

  return (
    <Card style={style}>
      <CardHeader>
        <CardTitle>Practice</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex justify-center">
          <img
            // src={riyaPortrait}
             src={type === "post" ? `${API_SERVER}/${data?.postassessment_image}` : `${API_SERVER}/${data?.preassessment_image}`}
            alt="Riya - Team Member"
            className="w-32 h-32 rounded-full object-cover border-4 border-primary/10"
          />
        </div>
        <div
          style={{
            marginTop: "16px",
            padding: "16px",
            borderRadius: "8px"
          }}
        >
          <h4 className='text-lg' style={{ marginBottom: "8px" }}>The Situation</h4>

          <p className="text-lg" style={{ lineHeight: "1.6" }}>
            {scenarioText || 'No speech content available.'}
          </p>
        </div>

        {audioSource && (
          <div className="space-y-2">
            <h4>Audio</h4>
            <audio controls className="w-full" src={audioSource} />
          </div>
        )}
      </CardContent>
    </Card>
  );
};
